import { DateTime } from "luxon";
export const dateTransform = value => {
  return DateTime.fromISO(value).toFormat("dd' / 'MM' / 'yyyy");
};

export const monthYearDateTransform = value => {
  return DateTime.fromISO(value + "-01").toFormat("MMMM yyyy");
};
